const lt = (a, b) => a < b;
export default lt;
